module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-dpk",
    attrs: {
      "name": "hrms-datepicker"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayInputDate),
      expression: "displayInputDate"
    }],
    ref: "datePickerInput",
    staticClass: "input-datepicker align-center",
    class: {
      'input-error': _vm.hasError
    },
    attrs: {
      "name": _vm.name + '-display',
      "disabled": _vm.disabled,
      "id": _vm.name
    },
    domProps: {
      "value": (_vm.displayInputDate)
    },
    on: {
      "blur": function($event) {
        _vm.displayCalendar()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayInputDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputDate),
      expression: "inputDate"
    }],
    ref: "datePickerInput",
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.inputDate)
    },
    on: {
      "blur": function($event) {
        _vm.calendarDate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option,
      "disabled": _vm.disabled,
      "limit": _vm.limit
    },
    on: {
      "change": function($event) {
        _vm.changeInputDate(arguments[0])
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57d491f1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsDatepicker/component.vue
// module id = 3782
// module chunks = 1